import { render, staticRenderFns } from "./AutomationFeature.vue?vue&type=template&id=87fe4926&scoped=true"
import script from "./AutomationFeature.vue?vue&type=script&lang=js"
export * from "./AutomationFeature.vue?vue&type=script&lang=js"
import style0 from "./AutomationFeature.vue?vue&type=style&index=0&id=87fe4926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe4926",
  null
  
)

export default component.exports